import { render, staticRenderFns } from "./UiRichPicker.vue?vue&type=template&id=19518117"
import script from "./UiRichPicker.vue?vue&type=script&lang=ts"
export * from "./UiRichPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports